/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {MainLayout} from '~/layouts/main';
import {Figure} from '~/components/Figure';
export const meta = {
  title: 'SRP | В реальной жизни',
  description: 'Как принцип единственной ответственности помогает решать задачи из реальной жизни, примеры и описание применения'
};
const MDXLayout = ({children}) => _jsx(MainLayout, {
  meta: meta,
  children: children
});
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      section: "section",
      h1: "h1",
      p: "p",
      h2: "h2",
      ul: "ul",
      li: "li",
      a: "a"
    }, _provideComponents(), props.components);
    return _jsxs(_components.section, {
      children: [_jsx(_components.h1, {
        children: "В реальной жизни"
      }), _jsx(_components.p, {
        children: "В реальной жизни SRP также позволяет решать задачи эффективнее. Ниже мы привели несколько примеров из проектов, над которыми работали."
      }), _jsxs(_components.section, {
        children: [_jsx(_components.h2, {
          children: "Валидация форм"
        }), _jsx(_components.p, {
          children: "В вебе одна из распространённых задач — валидация форм."
        }), _jsx(_components.p, {
          children: "Часто разработчики валидируют данные прямо в контроллерах форм. Это приводит к тому, что код контроллеров становится чрезмерно объёмным и нечитаемым. Также такой подход грозит дублированием кода, когда одинаковая валидация используется в разных формах."
        }), _jsx(_components.p, {
          children: "По принципу единственной ответственности следует разделять код, который меняется по разным причинам. В случае с валидацией формы есть две зоны ответственности."
        }), _jsx(_components.p, {
          children: "Первая — представление данных: вывод полей, значений, прогресса заполненности формы, ошибок и прочее. Вторая —  преобразование и обработка данных. Валидация попадает во вторую."
        }), _jsx(_components.p, {
          children: "В идеале валидация не должна ничего знать о том, в каком виде данные выводятся. Она должна работать только со значениями и принимать наборы данных в обговорённом формате, не привязываясь к форме вовсе."
        }), _jsxs(Figure, {
          children: [_jsx("img", {
            src: "/validation.svg"
          }), _jsx("figcaption", {
            children: "Принцип единственной ответственности позволяет сделать валидацию независимой от формата представления данных"
          })]
        }), _jsx(_components.p, {
          children: "Применение SRP для валидации позволяет:"
        }), _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "уменьшить код обработчиков форм, выделив валидацию в отдельный модуль;"
          }), "\n", _jsx(_components.li, {
            children: "держать валидацию значений в одном месте, собрав всё, что к ней относится в одном модуле;"
          }), "\n", _jsx(_components.li, {
            children: "валидировать не только формы, а любые наборы данных, которые соответствуют обговорённому формату валидатора."
          }), "\n"]
        })]
      }), _jsxs(_components.section, {
        children: [_jsx(_components.h2, {
          children: "Обработка сокет-событий"
        }), _jsxs(_components.p, {
          children: ["Для работы с данными в реальном времени в вебе часто используется ", _jsx(_components.a, {
            href: "https://socket.io",
            children: "socket.io"
          }), "."]
        }), _jsx(_components.p, {
          children: "Если в системе есть компоненты, которые каким-то образом работают с сокет-событиями, есть соблазн обрабатывать эти события прямо внутри компонента. На первый взгляд это даже не противоречит принципу: ведь события непосредственно связаны с компонентом и задачей, которую он решает."
        }), _jsxs(_components.p, {
          children: ["Но события в компоненте — это не обязательно сокет-события. У компонента по-хорошему должен быть интерфейс, который бы описывал события компонента и его поведение. (Подробнее об интерфейсах мы поговорим в разделе о ", _jsx(_components.a, {
            href: "/isp",
            children: "принципе разделения интерфейса"
          }), ".)"]
        }), _jsx(_components.p, {
          children: "По SRP настройку работы именно с сокетами следует вынести в отдельный модуль, причиной изменения которого будет только настройка и зависимость сокетов."
        })]
      }), _jsxs(_components.section, {
        children: [_jsx(_components.h2, {
          children: "Настройка бюджета во второй версии Тяжеловато"
        }), _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "http://www.fuckgrechka.ru/tzlvt/",
            children: "Тяжеловато"
          }), " — это приложение, которое помогает экономить. Пользователи указывают, сколько денег у них есть и на какой срок они хотят их растянуть. Приложение рассчитывает бюджет и сумму на день."]
        }), _jsx(_components.p, {
          children: "В первой версии бюджет и сумма на день были частями одной сущности — бюджета. Это сильно усложняло расчёты и увеличивало объём обработчиков пользовательских событий."
        }), _jsx(_components.p, {
          children: "По принципу единственной ответственности работа с суммой на день и с общим бюджетом на весь период — разные задачи. Причина изменения суммы на день — ввод траты; причина изменения бюджета — изменение настроек бюджета."
        }), _jsxs(Figure, {
          children: [_jsx("img", {
            src: "/tzlvt.jpg"
          }), _jsx("figcaption", {
            children: "«Общий бюджет» (слева) и «Сумма на день» (справа)"
          })]
        }), _jsx(_components.p, {
          children: "В обновлённой версии бюджет и сумма на день стали отдельными сущностями, которые общаются друг с другом через сообщения и команды."
        }), _jsx(_components.p, {
          children: "Это позволило:"
        }), _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "уменьшить количество эдж-кейсов при расчётах сумм;"
          }), "\n", _jsx(_components.li, {
            children: "сделать общение между сущностями более прозрачным;"
          }), "\n", _jsx(_components.li, {
            children: "разделить ответственность за обработку трат и настроек."
          }), "\n"]
        })]
      })]
    });
  }
}
export default MDXContent;
